module.exports = __webpack_public_path__ + "img/img1@2x.0400dee7.png";